import React from 'react';
import * as turf from '@turf/turf';

import { useDispatch, useSelector } from 'react-redux';
import { PLANNING_REDUCER } from '../../../../redux/ReducerNames';
import { FREQUENCY_TYPES, CHANGE_TYPES } from '../../../../redux/planning/Constants';
import { createPlanningAlertAsync } from '../../../../redux/planning/Actions';

import { Button, makeStyles, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => styles(theme));

function PlanningAlertActions () {
    const classes = useStyles();
    const currentProject = useSelector(state => state.project.currentProject);
    const planningAlertForm = useSelector(state => state[PLANNING_REDUCER].planningAlertForm);
    const planningAlertAreaFacet = useSelector(state => state.lookups.uiData.facetChoices.find(el => el.id === planningAlertForm.facetId));
    const isCreating = useSelector(state => state[PLANNING_REDUCER].isCreating);
    const maxArea = useSelector(state => state.user.features['planningAlerts'] ? (state.user.features['planningAlerts'].maxArea || 0) : 0);

    const dispatch = useDispatch();
    function dispatchCreatePlanningAlertAsync (form) {
        dispatch(createPlanningAlertAsync(currentProject.id, form));
    } 
  
    function createAlert () {
        if (validatePlanningAlert()) { 
            dispatchCreatePlanningAlertAsync(planningAlertForm);
        }
    }

    function validatePlanningAlert () {
        const { name, geojson, criteria, frequency, changeType } = planningAlertForm;
        if (!name) { return false; }
        if (!geojson) { return false; }
        switch (planningAlertAreaFacet.layerType) {
            case 'drawn':
                if (turf.area(geojson.geometry) > maxArea) { return false; }
                break;
            case 'fixed':
                if (!planningAlertForm.facetValid) { return false; }
                break;
            default:
                console.error(`Unimplemented Area Type ${planningAlertAreaFacet.layerType}`);
                return false;
        }
        if (!FREQUENCY_TYPES.includes(frequency)) { return false; }
        if (!CHANGE_TYPES.includes(changeType)) { return false; }
        return true;
    }

    const { error } = planningAlertForm;

    const isValidPlanningAlert = validatePlanningAlert();

    return (
        <>
            {
                Boolean(error) &&
                <Alert icon={false} severity="error" className={classes.alertRoot}>
                    <Typography variant="subtitle1">
                        {error.status} {error.statusText}
                    </Typography>
                    <Typography variant="body2">
                        {error.data}
                    </Typography>
                </Alert>
            }
            <div className={classes.actionsRoot}>
                <Button
                    variant="contained"
                    size="large"
                    color="secondary"
                    disabled={!isValidPlanningAlert || isCreating || !planningAlertForm.isDirty}
                    onClick={createAlert}
                >
                    { isCreating ? 'Creating' : 'Create' }
                </Button>
                {/* <Button
                    variant="contained"
                    size="large"
                    color="secondary"
                    // disabled={false}
                    onClick={() => {}}
                >
                    { 'Back' }
                </Button> */}
            </div>
        </>
    );
}

const styles = theme => ({
    actionsRoot: {
        display: 'flex',
        '& > *': {
            flex: '1 1 0',
            '&:not(:last-child)': {
                marginRight: 12
            }
        }
    },
    alertRoot: {
        padding: '10px'
    },
    valueIncrease: {
        color: theme.palette.success.main
    },
    valueDecrease: {
        color: theme.palette.error.main
    }
});

export default PlanningAlertActions;